
import { Vue } from "vue-class-component";

export default class Auth extends Vue {}
